import React from "react";
import { useSelector } from "react-redux";

import { FaCircleCheck } from "react-icons/fa6";

import { boxContainer, progressbar } from "..";
import { Images } from "../../config";

import "./styles.css";

const ProfileBuilder = ({ setPage }) => {
  const questionnaire = useSelector(
    (state) => state?.students?.student?.profileBuilder
  );

  const profileInfo = [
    {
      title: "General Information",
      icon: Images.ProfileBuildergeneral,
      percentage: questionnaire?.completion?.generalCompletion,
    },
    {
      title: "Address",
      icon: Images.ProfileBuilderlocation,
      percentage: questionnaire?.completion?.addressCompletion,
    },
    {
      title: "Education",
      icon: Images.ProfileBuildereducation,
      percentage: questionnaire?.completion?.educationCompletion,
    },
    ...(questionnaire?.curriculum
      ? [
          {
            title: "High School Grades",
            icon: Images.ProfileBuilderoverallgpa,
            percentage: questionnaire?.completion?.highSchoolGradesCompletion,
          },
        ]
      : []),
    {
      title: "Test Scores",
      icon: Images.ProfileBuildertestscores,
      percentage: questionnaire?.completion?.testScoresCompletion,
    },
    {
      title: "Emergency Contact",
      icon: Images.ProfileBuildercontacts,
      percentage: questionnaire?.completion?.contactsCompletion,
    },
    {
      title: "Counselor",
      icon: Images.ProfileBuildercounselor,
      percentage: questionnaire?.completion?.counselorCompletion,
    },
    {
      title: "Extra-Curricular Activities",
      icon: Images.ProfileBuilderactivities,
      percentage: questionnaire?.completion?.activitiesCompletion,
    },
  ];

  const universityPref = [
    {
      title: "Academics",
      icon: Images.ProfileBuilderacademics,
      percentage: questionnaire?.completion?.academicsCompletion,
    },
    {
      title: "Location",
      icon: Images.ProfileBuilderlocation,
      percentage: questionnaire?.completion?.locationCompletion,
    },
    {
      title: "Financial",
      icon: Images.ProfileBuilderfinancial,
      percentage: questionnaire?.completion?.financialCompletion,
    },
    {
      title: "People",
      icon: Images.ProfileBuilderpeople,
      percentage: questionnaire?.completion?.peopleCompletion,
    },
    {
      title: "Facilities",
      icon: Images.ProfileBuilderfacilities,
      percentage: questionnaire?.completion?.faciltiesCompletion,
    },
    {
      title: "Demographics",
      icon: Images.ProfileBuilderdemographics,
      percentage: questionnaire?.completion?.demographicsCompletion,
    },
    {
      title: "Others",
      icon: Images.ProfileBuilderothers,
      percentage: questionnaire?.completion?.othersCompletion,
    },
  ];
  return (
    <boxContainer.LiteBoxContainer>
      <div className="flex flex-col gap-3">
        <div className="flex flex-col gap-2">
          <div className="header-md">Profile Information</div>
          <div className="grid grid-cols-5 gap-4">
            {profileInfo?.map((item, index) => (
              <div
                className={`profile-builder-card ${
                  item?.percentage < 100 &&
                  questionnaire?.completion?.totalCompletion > 0 &&
                  "items-start"
                }`}
                key={index}
                onClick={() => setPage(item?.title)}
              >
                {item?.percentage < 100 &&
                  item?.percentage > 0 &&
                  questionnaire?.completion?.totalCompletion > 0 && (
                    <div className="absolute right-2 top-2 px-2 py-1 rounded-lg bg-liteBoxBorder text-[14px] font-semibold">
                      Not Completed
                    </div>
                  )}
                {item?.percentage === 0 &&
                  questionnaire?.completion?.totalCompletion > 0 && (
                    <div className="absolute right-2 top-2 px-2 py-1 rounded-lg bg-liteBoxBorder text-[14px] font-semibold">
                      Not started yet
                    </div>
                  )}
                <img src={item?.icon} className="h-[56px] w-[56px]" />
                <div className="font-semibold text-[16px]">{item?.title}</div>
                {item?.percentage === 100 && (
                  <div className="flex bg-main w-full gap-2 items-center justify-center h-[30px] text-white font-semibold">
                    <FaCircleCheck />
                    <div className="text-[14px]">Completed</div>
                  </div>
                )}
                {item?.percentage < 100 &&
                  item?.percentage > 0 &&
                  questionnaire?.completion?.totalCompletion > 0 && (
                    <progressbar.DefaultProgress percent={item?.percentage} />
                  )}
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div className="header-md">University Preference</div>
          <div className="grid grid-cols-5 gap-4">
            {universityPref?.map((item, index) => (
              <div
                className={`profile-builder-card ${
                  item?.percentage < 100 &&
                  questionnaire?.completion?.totalCompletion > 0 &&
                  "items-start"
                }`}
                key={index}
                onClick={() => setPage(item?.title)}
              >
                {item?.percentage < 100 &&
                  item?.percentage > 0 &&
                  questionnaire?.completion?.totalCompletion > 0 && (
                    <div className="absolute right-2 top-2 px-2 py-1 rounded-lg bg-liteBoxBorder text-[14px] font-semibold">
                      Not Completed
                    </div>
                  )}
                {item?.percentage === 0 &&
                  questionnaire?.completion?.totalCompletion > 0 && (
                    <div className="absolute right-2 top-2 px-2 py-1 rounded-lg bg-liteBoxBorder text-[14px] font-semibold">
                      Not started yet
                    </div>
                  )}
                <img src={item?.icon} className="h-[56px] w-[56px]" />
                <div className="font-semibold text-[16px]">{item?.title}</div>
                {item?.percentage === 100 && (
                  <div className="flex bg-main w-full gap-2 items-center justify-center h-[30px] text-white font-semibold">
                    <FaCircleCheck />
                    <div className="text-[14px]">Completed</div>
                  </div>
                )}
                {item?.percentage < 100 &&
                  item?.percentage > 0 &&
                  questionnaire?.completion?.totalCompletion > 0 && (
                    <progressbar.DefaultProgress percent={item?.percentage} />
                  )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </boxContainer.LiteBoxContainer>
  );
};

export default ProfileBuilder;
